import { Tag, TTagVariant } from "@/components/elements/Tag";
import { background, black, labelColor, state } from "@/theme/colors";
import { ERecruitmentStatus } from "@/types/enum";
import { FC, useMemo } from "react";

export type TTalentStatusTagProps = {
  status: number;
  title: string;
  variant: TTagVariant;
};

export const TalentStatusTag: FC<TTalentStatusTagProps> = ({ status, title, variant }) => {
  const commonStyleText = { "& .MuiTypography-root": { color: black[30], fontWeight: "400" } };

  type StatusConfig = { color: string; sx?: object };

  const STATUS_CONFIG: Record<ERecruitmentStatus, StatusConfig> = {
    [ERecruitmentStatus.DRAFT]: { color: background.disable, sx: commonStyleText },
    [ERecruitmentStatus.ALREADY_HIRED]: { color: labelColor.success, sx: commonStyleText },
    [ERecruitmentStatus.JOB_SEEKING]: { color: labelColor.progress, sx: commonStyleText },
    [ERecruitmentStatus.OFFER_ACCEPTED]: { color: labelColor.warning, sx: commonStyleText },
    [ERecruitmentStatus.OTHER_COMPANY_OFFER]: { color: state.error_2, sx: commonStyleText },
    [ERecruitmentStatus.JOB_HUNTING_FINISHED]: { color: state.error_2, sx: commonStyleText },
  };

  const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG];

  const tagProps = useMemo<StatusConfig>(() => {
    return config ?? { color: background.disable };
  }, [status]);

  return <Tag variant={variant} {...tagProps} title={title} />;
};
